export default __webpack_public_path__ + "static/media/Kosalan Endurance.f2d0da37.jpg";